<template>
  <div v-if="membre != null">
    <v-row>
      <h4>
        <span v-if="membre.statutAdhesion">
          {{ membre.statutAdhesion.lang00 }}
        </span>
      </h4>
    </v-row>
    <v-row class="d-flex justify-space-between mt-4">
      <v-col md="6" col="12">
        <v-row dense>
          <v-col md="6" class="title-member">
            <strong>Rue 1:</strong>
          </v-col>
          <v-col md="6" class="data-member">
            <span v-if="membre.cartesDeVisite[0]">
              {{ membre.cartesDeVisite[0].rue1 }}
            </span>
          </v-col>
        </v-row>
      </v-col>
      <v-col md="6" col="12">
        <v-row dense>
          <v-col md="6" class="title-member">
            <v-icon>fa-globe</v-icon>
          </v-col>
          <v-col md="6" class="data-member">
            <span v-if="membre.cartesDeVisite[0] && membre.cartesDeVisite[0].pm">
              {{ membre.cartesDeVisite[0].pm.siteWeb }}
            </span>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="d-flex justify-space-between">
      <v-col md="6" col="12">
        <v-row dense>
          <v-col md="6" class="title-member">
            <strong>Rue 2:</strong>
          </v-col>
          <v-col md="6" class="data-member">
            <span v-if="membre.cartesDeVisite[0]">
              {{ membre.cartesDeVisite[0].rue2 }}
            </span>
          </v-col>
        </v-row>
      </v-col>
      <v-col md="6" col="12">
        <v-row dense>
          <v-col md="6" class="title-member">
            <v-icon>fa-envelope</v-icon>
          </v-col>
          <v-col md="6" class="data-member">
            <span v-if="membre.cartesDeVisite[0]">
              {{ membre.cartesDeVisite[0].courriel }}
            </span>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="d-flex justify-space-between">
      <v-col md="6" col="12">
        <v-row dense>
          <v-col md="6" class="title-member"> </v-col>
          <v-col md="6" class="data-member"> </v-col>
        </v-row>
      </v-col>
      <v-col md="6" col="12">
        <v-row dense>
          <v-col md="6" class="title-member">
            <v-icon>fa-phone-square</v-icon>
          </v-col>
          <v-col md="6" class="data-member">
            <span v-if="membre.cartesDeVisite[0]">
              {{ membre.cartesDeVisite[0].telephone }}
            </span>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="d-flex justify-space-between">
      <v-col md="12" cols="12">
        <v-row dense>
          <v-col class="title-member">
            <strong>Code postal:</strong>
          </v-col>
          <v-col class="data-member">
            <span v-if="membre.cartesDeVisite[0]">
              {{ membre.cartesDeVisite[0].codePostal }}
            </span>
          </v-col>
          <v-col class="title-member">
            <strong>Ville:</strong>
          </v-col>
          <v-col class="data-member">
            <span v-if="membre.cartesDeVisite[0]">
              {{ membre.cartesDeVisite[0].ville }}
            </span>
          </v-col>
          <v-col class="title-member">
            <strong>Province:</strong>
          </v-col>
          <v-col class="data-member">
            <span v-if="membre.cartesDeVisite[0] != null && membre.cartesDeVisite[0].province">
              {{ membre.cartesDeVisite[0].province.lang00 }}
            </span>
          </v-col>
          <v-col class="title-member"> <v-icon>fa-phone-square</v-icon> <strong>Direct:</strong> </v-col>
          <v-col class="data-member">
            <span v-if="membre.cartesDeVisite[0]">
              {{ membre.cartesDeVisite[0].ligneDirecte }}
            </span>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <hr />
    <v-row class="mt-4">
      <strong>Pratique professionnelle :</strong> {{ textAuthProf }}
      <span v-if="filteredAuthprofessionnelle.length > 5">
        <span v-if="showAllAuthProf == false">
          <a class="ml-4" style="text-decoration: underline" v-on:click="showAllAuthProf = true">Tout afficher</a>
        </span>
        <span v-if="showAllAuthProf == true">
          <a class="ml-4" style="text-decoration: underline" v-on:click="showAllAuthProf = false">Réduire</a>
        </span>
      </span>
    </v-row>
    <v-row class="mt-4">
      <strong>Champs d'exercice :</strong> {{ textChamp }}
      <span v-if="filteredChamp.length > 5">
        <span v-if="showAllChamp == false">
          <a class="ml-4" style="text-decoration: underline" v-on:click="showAllChamp = true">Tout afficher</a>
        </span>
        <span v-if="showAllChamp == true">
          <a class="ml-4" style="text-decoration: underline" v-on:click="showAllChamp = false">Réduire</a>
        </span>
      </span>
    </v-row>
    <v-row class="mt-4">
      <strong>Expertise particulière :</strong> {{ textExpertise }}
      <span v-if="filteredExpertise.length > 5">
        <span v-if="showAllExpert == false">
          <a class="ml-4" style="text-decoration: underline" v-on:click="showAllExpert = true">Tout afficher</a>
        </span>
        <span v-if="showAllExpert == true">
          <a class="ml-4" style="text-decoration: underline" v-on:click="showAllExpert = false">Réduire</a>
        </span>
      </span>
    </v-row>
  </div>
</template>

<script>
export default {
  props: ["membre"],
  components: {},
  data() {
    return {
      showAllAuthProf: false,
      showAllChamp: false,
      showAllExpert: false
    }
  },
  computed: {
    filteredAuthprofessionnelle: function () {
      return this.filterArray("Pratique professionnelle")
    },
    textAuthProf: function () {
      return this.getText(this.filteredAuthprofessionnelle, this.showAllAuthProf)
    },
    filteredChamp: function () {
      return this.filterArray("Champs d’exercice")
    },
    textChamp: function () {
      return this.getText(this.filteredChamp, this.showAllChamp)
    },
    filteredExpertise: function () {
      return this.filterArray("Expertises particulières")
    },
    textExpertise: function () {
      return this.getText(this.filteredExpertise, this.showAllExpert)
    }
  },
  mounted() {
    this.initialize()
  },
  methods: {
    initialize() {
      console.log(this.membre)
    },
    filterArray(type) {
      if (this.membre && this.membre.renseignementsProfessionnels) {
        return this.membre.renseignementsProfessionnels.filter((r) => r.designation && r.typeRp && r.typeRp.lang00 == type).slice()
      } else {
        return []
      }
    },
    getText(array, showAll) {
      if ((array != null) & (array.length > 0)) {
        if (showAll == true) {
          return array.map((r) => r.designation && r.designation.lang00).toString()
        } else {
          return array
            .slice(0, 5)
            .map((r) => r.designation.lang00)
            .toString()
        }
      } else {
        return ""
      }
    }
  }
}
</script>

<style scoped>
.title-member {
  text-align: right;
}

.data-member {
  text-align: left;
}

hr {
  border: 1px solid silver;
}
</style>